import type { MlPersonByAssetAndVersionNullable } from '@iconik-io/iconik-api/src/services/ml';

import ContextMenu from '../../../components/context_menu/context_menu';
import contextMenuConnector from '../../../components/context_menu/context_menu_connector';
import type {
  ContextMenuItemDefinition,
  GetDefinition,
} from '../../../components/context_menu/types';
import { FACE_RECOGNITION_REMOVE_PERSON_MODAL } from '../../../constants/modals';
import {
  CONTEXT_PANELS_FACE_RECOGNITION,
  connectContextMenuConsumer,
} from '../../../contexts/context_menu';
import { historyPush } from '../../../ducks/history/actions';
import { openModal } from '../../../ducks/modals_manager/slice';
import { ICONS } from '../../../icons/icon';
import type { AppState } from '../../../store/types';
import { getStatus } from '../utils';

const getDefinition: GetDefinition<
  MlPersonByAssetAndVersionNullable,
  AppState
> = ({ contextItems, onMenuItemClick }, state) => {
  const items: ContextMenuItemDefinition[] = [];
  const userRoles = state.rolesReducer.userRoles;
  const isSingleSelection = contextItems.length === 1;

  if (isSingleSelection) {
    items.push({
      id: 'goto_person',
      label: 'View person',
      icon: ICONS.Open,
      multiple: true,
      action: () => (dispatch) => {
        dispatch(
          historyPush(`/admin/face_recognition/persons/${contextItems[0].id}`),
        );
      },
    });
  }
  const hasNewStatus = contextItems[0] && getStatus(contextItems[0]) === 'NEW';
  if (
    onMenuItemClick &&
    userRoles.canEditPerson &&
    isSingleSelection &&
    !hasNewStatus
  ) {
    items.push({
      id: 'change_person',
      label: 'Change person…',
      icon: ICONS.PersonChange,
      action: (action, event) => () => {
        onMenuItemClick?.(action, event);
      },
    });
  }
  if (userRoles.canDeletePerson) {
    items.push({
      id: 'remove_person',
      label: isSingleSelection
        ? 'Remove person from asset…'
        : 'Remove persons from asset…',
      icon: ICONS.TrashBin,
      multiple: true,
      action: () => (dispatch) => {
        dispatch(
          openModal({
            id: FACE_RECOGNITION_REMOVE_PERSON_MODAL,
            contextItems,
            options: { analyticsPlace: 'panel' },
          }),
        );
      },
    });
  }
  return {
    items,
    objectType: 'persons',
  };
};

const RecognizedFaceContextMenu = connectContextMenuConsumer(
  contextMenuConnector(getDefinition)(ContextMenu),
  CONTEXT_PANELS_FACE_RECOGNITION,
);

export default RecognizedFaceContextMenu;
